import React, {Component} from 'react';

class TopBar extends Component {
  render() {
    return (
      <div id="topNavBar" className="sticky-top">
       <div className="container">
       <ul className="navbar">
        <li id="phone-top" className="pull-left nav-item">
          <a href="tel:2245436968"><i className="fas fa-phone fw"></i> (224)-543-6968</a>
        </li>
        <li id="email-top" className="pull-right nav-item">
          <a href="#label-name"><i className="fas fa-envelope fw"></i> info@moorebenefitresources.com</a>
        </li>
        </ul>
       </div>
      </div>
    )
  }
}

export default TopBar;



// WEBPACK FOOTER //
// ./src/components/TopBar.js